import { z } from "zod";

/**
 * A schema that validates a string that can be converted to a integer.
 */
export const NumberStringSchema = z
  .string()
  .regex(/^\d+?$/, "Invalid number")
  .transform(Number);
